import angular from 'angular';
import _ from 'lodash';

class containerEditCtrl {
    /* @ngInject */
    constructor(
        $scope,
        $translate,
        $uibModal,
        AuthSvc,
        toastr,
        LANGUAGES,
        PrincipalService,
        CompanyService,
        LadProviderService,
        ContainerService,
        UtilSvc,
        Containers,
        $window,
        logger,
        DocumentModelDA,
        EMAIL_REGEXP
    ) {
        this.$scope = $scope;
        this.$translate = $translate;
        this.$uibModal = $uibModal;
        this.AuthSvc = AuthSvc;
        this.toastr = toastr;
        this.LANGUAGES = LANGUAGES;
        this.PrincipalService = PrincipalService;
        this.CompanyService = CompanyService;
        this.LadProviderService = LadProviderService;
        this.ContainerService = ContainerService;
        this.UtilSvc = UtilSvc;
        this.Containers = Containers;
        this.$window = $window;
        this.logger = logger;
        this.DocumentModelDA = DocumentModelDA;
        this.modelSearch = [];
        this.EMAIL_REGEXP = EMAIL_REGEXP;
    }

    $onInit() {
        this.containerDetail = this.container.containerDetailsDto;
        this.hubpharmaModels = [];

        // Dans le cas des containers déjà existants, si on est sur un HubFacture, alors on récupère les modèles Hubpharma
        if (this.isContainerModeHubInvoice()) {
            this.DocumentModelDA.getModelByCategoryAndType('HUBPHARMA', 'MODEL', 'INVOICE').then(data => {
                this.hubpharmaModels = data;
            });
        }

        this.containerContext = _.pick(this.container, [
            'principalHasExtraMappingData',
            'companyPerimeters',
            'companyName',
        ]);

        this.fileUpload = {
            filedata: null,
        };

        this.includes = {
            formMessages: require('../../../common/form-messages.html'),
        };

        this.configuration = {
            canEdit: this.AuthSvc.isAuthorized('CONFIGURATOR'),
            autoRoutingDisabled: true,
            canCheckMail: this.AuthSvc.isAuthorized('ADMIN'),
        };

        // Liste des donneurs d'ordre
        this.principals = this.getPrincipals();

        // Liste des prestataires
        this.ladProviders = this.getLadProviders();
        this.ladProviders.$promise.then(lp => {
            this.zedocLadProvider = _.find(lp, ['eId', 'ZE']);

            // Dans le cas où DocIA n'est pas disponible, on choisi Zedoc par défaut
            // NB : In fine, le ternaire est à supprimer une fois que DocIA sera disponible sur tous les environements
            const docIALadProvider = _.find(lp, ['eId', 'DI']);
            this.hubpharmaLadProviderId = docIALadProvider ? docIALadProvider.id : this.zedocLadProvider.id;
        });

        this.languages = this.LANGUAGES;

        this.emailTags = {
            reportNotifEmail: [],
            notifEmail: [],
            notifCcEmail: [],
        };

        this.init();
    }

    init() {
        if (this.containerDetail.containerMode === undefined) {
            this.containerDetail.containerMode = 'STANDARD';
        }

        if (this.AuthSvc.isAuthorized('CONFIGURATOR') && this.mode === 'details') {
            this.mode = 'edit';
        }

        this._computeAutoRoutingEnablement();

        this._initTagEmails();

        /* recuperation des modeles de facture business control */
        this.DocumentModelDA.getModelByCategoryAndType('STANDARD', 'MODEL', 'INVOICE').then(data => {
            this.modelSearch = _.union(this.modelSearch, data);
        });

        this.DocumentModelDA.getModelByCategoryAndType(this.container.principalEid, 'MODEL', 'INVOICE').then(data => {
            this.modelSearch = _.union(this.modelSearch, data);
        });
    }

    _initTagEmails() {
        this.emailTags.reportNotifEmail = this.UtilSvc.splitMail(this.containerDetail.reportNotifEmail);
        this.emailTags.notifEmail = this.UtilSvc.splitMail(this.containerDetail.notifEmail);
        this.emailTags.notifCcEmail = this.UtilSvc.splitMail(this.containerDetail.notifCcEmail);
    }

    getPrincipals() {
        return this.PrincipalService.findAll();
    }

    getLadProviders() {
        var providers = this.LadProviderService.findAll();
        providers.$promise.then(() => this._computeAutoRoutingEnablement());
        return providers;
    }

    modify() {
        this.mode = 'edit';
    }

    openMappingFile(containerId) {
        return this.Containers.getMappingFile(containerId);
    }

    deleteMapping() {
        this.containerDetail.mappingId = null;
        this.containerDetail.mappingMode = 'GENERIC';
        this.form.$setDirty();
    }

    canSave() {
        const selectedPerimeter = this.containerContext.companyPerimeters.find(
            perimeter => perimeter.code === this.containerDetail.perimeterCode
        );
        const isConfidential = selectedPerimeter ? selectedPerimeter.isConfidential : false;

        if (
            this.containerDetail.containerStatus === 'DISABLE' &&
            this.containerDetail.containerType === 'UPLOAD' &&
            this.containerDetail.containerMode === 'KISS'
        ) {
            this.toastr.error(this.$translate.instant('principal.container_details.fail_upload_disable'));
            return false;
        }

        if (
            isConfidential &&
            (this.containerDetail.containerMode !== 'KISS' || this.containerDetail.containerType !== 'MAIL')
        ) {
            this.toastr.error(this.$translate.instant('principal.container_details.confidential_not_allowed'));
            return false;
        }

        return this.compatibleApplicationType() && !this.form.$invalid;
    }

    /**
     * Test si le mode et le type de container sont compatibles.
     */
    compatibleApplicationType() {
        if (
            (this.containerDetail.containerMode === 'STANDARD' && this.containerDetail.containerType === 'UPLOAD') ||
            (this.containerDetail.containerMode === 'KISS' && this.containerDetail.containerType === 'FILE')
        ) {
            return false;
        }
        return true;
    }

    updateTemplates() {
        if (this.containerDetail.containerType === 'FILE' || this.containerDetail.containerType === 'MAIL') {
            this.ContainerService.getContainerTemplatesForm(
                {
                    language: this.containerDetail.language,
                    containerId: this.containerDetail.containerId,
                    containerMode: this.containerDetail.containerMode,
                },
                data => {
                    this.containerDetail.firstShipmentTemplate = data.firstShipmentTemplate;
                    this.containerDetail.unAllowTemplate = data.unAllowTemplate;
                    this.containerDetail.rejectTemplate = data.rejectTemplate;
                    this.containerDetail.acknowledgmentTemplate = data.acknowledgmentTemplate;
                    this.containerDetail.batchNotIndexedTemplate = data.batchNotIndexedTemplate;
                    this.containerDetail.subjectBatchNotIndexedTemplate = data.subjectBatchNotIndexedTemplate;
                }
            );
        }

        if (this.isContainerModeHubInvoice()) {
            this.DocumentModelDA.getModelByCategoryAndType('HUBPHARMA', 'MODEL', 'INVOICE').then(data => {
                this.hubpharmaModels = data;
                this.containerDetail.mappingModelBC = data[0];
            });

            this.containerDetail.mappingMode = 'BUSINESS_CONTROL';
            this.containerDetail.platformPath = '/docrepo';
            this.containerDetail.mainLadProviderId = this.hubpharmaLadProviderId;
            this.containerDetail.dematSymetric = false;
            this.containerDetail.dematMode = 'PAPER';
        }
    }

    // Renvoie les modèles d'Hubpharma si le container est HubFacture, et renvoie les modèles classiques sinon
    getModels() {
        if (this.isContainerModeHubInvoice()) return this.hubpharmaModels;
        return this.modelSearch;
    }

    // Renvoie un booléen indiquant si on est sur un container HubFacture
    isContainerModeHubInvoice() {
        return this.containerDetail.containerMode === 'HUB_INVOICE';
    }

    onCompanyChange() {
        var promise = this.CompanyService.get({ companyId: this.containerDetail.companyId }).$promise;
        promise.then(data => {
            this.containerDetail.companyPerimeters = data.perimeters;
        });
    }

    // Desactive la checkbox de symetrie du mode de demat si celui-ci est 'PAPIER'
    updateSymetryCbx() {
        if (this.container.dematMode === 'PAPER') {
            this.containerDetail.dematSymetric = false;
        }
    }

    // Reussite de la sauvegarde du container
    onSaveSuccess(data) {
        if (this.fileUpload.filedata) {
            this.Containers.uploadMappingFile(this.fileUpload.filedata, data.containerDetailsDto.containerId).then(
                data => {
                    this.containerDetail.mappingId = data.data;
                    this.containerDetail.mappingFilename = this.fileUpload.filedata.name;
                    this.containerDetail.mappingMode = 'SPECIFIC';

                    this.fileUpload.filedata = null;
                    this.finishSaving(data);
                },
                error => {
                    if (error.data && error.data.code === 'INVALID_TEMPLATE') {
                        this.logger.error(error.data.message, null, 'principal.container.invalid_mapping_plateform');
                    } else {
                        this.logger.error('error.save');
                    }
                }
            );
        } else {
            this.finishSaving(data);
        }
    }

    finishSaving(data) {
        this.toastr.success(this.$translate.instant('SAVE_SUCCESS'), this.$translate.instant('SAVE_TITLE'));
        this.form.$setPristine();
        this.containerDetail.containerId = data.containerDetailsDto.containerId;
        this.mode = 'details';
    }

    // Echec de la sauvegarde du container
    onSaveFailure(error) {
        if (error.data.code === 'NOT_FOUND_001') {
            this.openPlatformPopup();
        } else {
            var message = this.$translate.instant('SAVE_FAILURE') + '<br/>' + error.data.message;
            this.toastr.error(message, this.$translate.instant('SAVE_TITLE'), {
                allowHtml: true,
            });
        }
    }

    // Sauvegarde d'un container
    save(createRemoteFolder) {
        this.cleanContainer();
        if (this.canSave()) {
            var promise;
            //formater les emails
            this._prepareEmails();
            // raz du modele
            if (
                !['STANDARD', 'HUB_INVOICE'].includes(this.containerDetail.containerMode) ||
                this.containerDetail.mappingMode !== 'BUSINESS_CONTROL'
            ) {
                this.containerDetail.mappingModelBC = undefined;
            }

            if (this.containerDetail.containerId) {
                promise = this.Containers.update(
                    { containerId: this.containerDetail.containerId, createRemoteFolders: createRemoteFolder },
                    this.containerDetail
                ).$promise;
            } else {
                promise = this.Containers.save(
                    { createRemoteFolders: createRemoteFolder },
                    this.containerDetail
                ).$promise;
            }
            promise.then(
                data => this.onSaveSuccess(data),
                error => this.onSaveFailure(error)
            );
        }
    }

    cleanContainer() {
        if (this.container.containerDetailsDto.containerType !== 'FILE') {
            this.containerDetail.notifTime = undefined;
        }
        if (this.container.containerDetailsDto.containerType !== 'MAIL') {
            this.containerDetail.acknowledgmentTemplate = undefined;
            this.containerDetail.sendConfirm = undefined;
        }
        if (
            !this.container.containerDetailsDto.sendConfirm ||
            this.container.containerDetailsDto.containerType !== 'MAIL' ||
            this.container.containerDetailsDto.containerMode === 'KISS'
        ) {
            this.containerDetail.firstShipmentTemplate = undefined;
        }
        if (this.container.containerDetailsDto.containerType === 'UPLOAD') {
            this.containerDetail.containerName = undefined;
        }
    }

    _prepareEmails() {
        this.containerDetail.reportNotifEmail = this.UtilSvc.joinMail(this.emailTags.reportNotifEmail);
        this.containerDetail.notifEmail = this.UtilSvc.joinMail(this.emailTags.notifEmail);
        this.containerDetail.notifCcEmail = this.UtilSvc.joinMail(this.emailTags.notifCcEmail);
    }

    // Evénement de changement du type de traitement (générique, spécifique)
    onChangeTreatment() {
        this._computeAutoRoutingEnablement();
    }

    // Evénément de changement du prestataire de LAD PLATFORM
    onChangeLadProviderMain() {
        this._computeAutoRoutingEnablement();
    }

    _computeAutoRoutingEnablement() {
        this.configuration.autoRoutingDisabled =
            this.containerDetail.mappingMode === 'SPECIFIC' ||
            (this.containerDetail.mappingMode === 'BUSINESS_CONTROL' &&
                this.containerContext.principalHasExtraMappingData);
        if (!this.configuration.autoRoutingDisabled) {
            // Est-ce que le prestataire de LAD choisi doit interdire l'autoroutage
            var ladProvider = _.find(this.ladProviders, ['id', this.containerDetail.mainLadProviderId]);
            this.configuration.autoRoutingDisabled = !ladProvider || ladProvider.special;
        }

        // Désactive l'autoroutage si cette option n'est pas sélectionnable
        if (this.configuration.autoRoutingDisabled && this.containerDetail.autoRouting) {
            this.containerDetail.autoRouting = false;
        }
    }

    // Affichage de la fenêtre de confirmation pour la création des répertoire d'échange avec les plateformes de demat.
    openPlatformPopup() {
        return this.$uibModal
            .open({
                component: 'containerPlatform',
                resolve: {
                    container: () => {
                        return this.containerDetail;
                    },
                },
                backdrop: 'static',
                keyboard: false,
            })
            .result.then(
                () => this.closePlatformPopup(),
                () => {}
            );
    }

    // Confirmation de la création du répertoire d'échange avec la plateforme de demat et fermeture de la popup.
    closePlatformPopup() {
        this.save(true);
    }

    isEmail(value) {
        // Regexp utilisé dans Angular pour valider les input[type=email]
        return this.EMAIL_REGEXP.test(value.text);
    }

    // Fonction de filtre d'un prestataire de LAD pour ne conserver que les prestataires sélectionnables dont le mode (standard ou kiss) est cohérent avec le mode du container.
    // Au niveau du filtre on applique aussi la régle suivante : si prestataire plateforme est différent de ZEDOC alors on ne peut pas selectionner la valeur ZEDOC au niveau de la liste
    ladProviderModeFilter(that) {
        return ladProvider => {
            const { containerMode, mainLadProviderId } = that.containerDetail;
            if (containerMode === 'HUB_INVOICE') {
                return ladProvider.id === mainLadProviderId;
            }
            let selectable =
                ladProvider.selectable &&
                (!ladProvider.containerModeRestriction || ladProvider.containerModeRestriction === containerMode);
            if (selectable && !this.isCreateMode()) {
                selectable =
                    mainLadProviderId === this.zedocLadProvider.id ||
                    (mainLadProviderId !== this.zedocLadProvider.id && ladProvider.eId !== 'ZE');
            }
            return selectable;
        };
    }

    openModalDelete() {
        return this.$uibModal
            .open({
                component: 'containerDeleteModal',
                resolve: {
                    containerId: () => {
                        return this.containerDetail.containerId;
                    },
                },
                backdrop: 'static',
                keyboard: false,
            })
            .result.then(
                () => {
                    this.back();
                },
                () => {}
            );
    }

    back() {
        this.$window.history.back();
    }

    displayPrefix() {
        return (
            this.containerDetail.mappingMode == 'GENERIC' ||
            (this.containerDetail.mappingMode !== 'SPECIFIC' && this.containerDetail.containerMode === 'KISS')
        );
    }

    displayModelBCName() {
        return (
            this.containerDetail.mappingMode === 'BUSINESS_CONTROL' &&
            ['STANDARD', 'HUB_INVOICE'].includes(this.containerDetail.containerMode)
        );
    }

    isModelBCDisabled() {
        return this.mode == 'details';
    }

    disableLadproviderPlatform() {
        return (
            (!this.isCreateMode() &&
                this.zedocLadProvider &&
                this.zedocLadProvider.id === this.containerDetail.mainLadProviderId) ||
            this.isContainerModeHubInvoice()
        );
    }

    isCreateMode() {
        return this.mode !== 'details' && this.mode !== 'edit';
    }
}

angular.module('principal').component('containerEdit', {
    templateUrl: require('./container-details.html'),
    controller: containerEditCtrl,
    bindings: {
        container: '<',
        mode: '<',
    },
});
